import Head from 'next/head'
import styled from 'styled-components'

import FooterPageLayout from 'components/FooterPageLayout'
import Spacer from 'components/Spacer'

import LicensingData from 'data/MarketingData/LicensingData'

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`

const Header = styled.h5`
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  margin-bottom: 0;
`

const StyledText = styled.p`
  margin: 0;
  padding: 0;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  white-space: pre;

  color: ${props => props.theme.colors.black};
  opacity: 0.7;
`

const StyledLink = styled.a`
  color: ${props => props.theme.colors.purple};
  text-decoration: underline;
  text-decoration-color: ${props => props.theme.colors.purple};
  text-underline-position: under;
  padding-top: 4px; /* font-correction */
  &:visited {
    color: ${props => props.theme.colors.purple};
  }
`

const Licensing = () => (
  <FooterPageLayout
    imageSrc={`${process.env.CDN_BASE_URL}/q_auto/amazon/assets/footer-hero-2.png`}
    title="Official Real Estate Licensing Information"
  >
    <Head>
      <title>Real Estate Licensing Information | HomeLister</title>
      <meta
        name="description"
        content="Find out which states HomeLister has Real Estate Licensing set up for. Sell your home today with HomeLister."
      />
      <meta
        name="keywords"
        content="Real Estate Licensing, HomeLister"
      />
    </Head>
    <FlexContainer>
      {Object.keys(LicensingData).map(state => (
        <>
          <Header>{LicensingData[state].name}</Header>
          <StyledText>{LicensingData[state].licensing}</StyledText>
          {state === 'texas' && (
            <StyledLink
              href={`${process.env.S3_BASE_URL}/TX+IABS.pdf`}
              target="_blank"
            >
              TREC: Info about Brokerage Services
            </StyledLink>
          )}
          <Spacer size={30} />
        </>
      ))}
    </FlexContainer>
  </FooterPageLayout>
)

export default Licensing
